// math routines
export const FACTOR = 1.118;

export enum EFormulaKeys {
    Rca = "rca",
    Rpm = "rpm",
    R = "r",
}
